<script>
export default {
  name: 'AvatarProfil',
  props: {
    value: {
      type: String,
      required: true
    }
  }
}
</script>

<template>
  <img
      class="w-full h-full rounded-lg"
      :src="`https://api.dicebear.com/9.x/personas/svg?seed=${value}`"
      alt="Helene avatar"
  />
</template>
